export default __webpack_public_path__ + "static/media/TokiRGB_red.51404954.png";